import FormattedMessage from 'I18n/components/FormattedMessage';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIInputStaticLabel from 'UIComponents/input/UIInputStaticLabel';
import UINumberInput from 'UIComponents/input/UINumberInput';
import UIFormControl from 'UIComponents/form/UIFormControl';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterOperatorRollingPropertyUpdated = ({
  condition,
  disabled,
  onChange,
  onBlur,
  error,
  inputUse,
  readOnly
}) => {
  // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'days' implicitly has an 'any' typ... Remove this comment to see the full error message
  const handleChangeNumberOfDays = ({
    target: {
      value: days
    }
  }) => onChange(syntheticEvent(condition.set('numberOfDays', days)));
  const isError = error.get('error');
  const errorMessage = error.get('message');
  return /*#__PURE__*/_jsx(UIFormControl, {
    "aria-label": I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorInput.ariaLabel'),
    error: isError,
    validationMessage: isError ? errorMessage : null,
    children: /*#__PURE__*/_jsx(UIInputStaticLabel, {
      position: "end",
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'customerDataFiltersUI.customerDataFilters.FilterOperatorRollingPropertyUpdated.days'
      }),
      children: /*#__PURE__*/_jsx(UINumberInput, {
        disabled: disabled,
        min: 0,
        onBlur: onBlur
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        ,
        onChange: handleChangeNumberOfDays,
        readOnly: readOnly,
        use: inputUse,
        value: condition.numberOfDays
      })
    })
  });
};
export default FilterOperatorRollingPropertyUpdated;